import { render, staticRenderFns } from "./ForgeViewerHeatmapWidget.vue?vue&type=template&id=48af0947&"
import script from "./ForgeViewerHeatmapWidget.vue?vue&type=script&lang=js&"
export * from "./ForgeViewerHeatmapWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports